import { render, staticRenderFns } from "./pdfShopSaleDetail.vue?vue&type=template&id=470182e4&"
import script from "./pdfShopSaleDetail.vue?vue&type=script&lang=js&"
export * from "./pdfShopSaleDetail.vue?vue&type=script&lang=js&"
import style0 from "./pdfShopSaleDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports